<div class="container">
    <div class="card">
        <div class="card-body">
            <div class="panel panel-primary">
                <div class="panel-heading custom-panel">
                    <div class="titulo-painel-left">
                        <h2>Notificações de Cancelamento</h2>
                    </div>
                    <div class="menu-painel">
                        <button mat-stroked-button color="primary" (click)="add()" matTooltip="Criar">Novo
                        </button>
                    </div>
                </div>
                <div class="panel-body" (window:resize)="onResize($event)">

                    <form [formGroup]="formularioDeConsultaDeNotificacoes" (ngSubmit)="onSubmit()">

                        <div class="form-row">
                            <mat-form-field class="form-group col-lg-8 col-md-8 col-sm-8 col-12">
                                <mat-label>Data Inicial e Final</mat-label>

                                <mat-date-range-input [rangePicker]="picker">
                                    <input matStartDate placeholder="Data Inicial"
                                        formControlName="dataInicialLoteNotificacao">
                                    <input matEndDate placeholder="Data Final"
                                        formControlName="dataFinalLoteNotificacao">
                                </mat-date-range-input>

                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-date-range-picker #picker></mat-date-range-picker>

                                <mat-error
                                    *ngIf="formularioDeConsultaDeNotificacoes.controls.dataInicialLoteNotificacao.hasError('invalidDate') || formularioDeConsultaDeNotificacoes.controls.dataFinalLoteNotificacao.hasError('invalidDate')">
                                    Datas inválidas ou com intervalos não permitidos.
                                </mat-error>
                            </mat-form-field>

                            <mat-form-field class="form-group col-lg-4 col-md-4 col-sm-4 col-12">
                                <mat-label>Num. Lote</mat-label>
                                <input matInput type="number" value="Num. Lote" class="form-control" id="numLote"
                                    trim="blur" name="numLote" formControlName="numLote">
                            </mat-form-field>
                        </div>

                        <div class="form-row">
                            <mat-form-field style="margin-top: 6.5px;"
                                class="form-group col-lg-8 col-md-7 col-sm-8 col-12">
                                <mat-label>Motivo Notificação</mat-label>
                                <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                                    cdkAutosizeMinRows="1" cdkAutosizeMaxRows="2" formControlName="dscMotivoNotificacao"
                                    name="dscMotivoNotificacao" id="dscMotivoNotificacao" maxlength="255"
                                    upperCase></textarea>
                            </mat-form-field>

                            <div class="form-group col-lg-2 col-md-2 col-sm-4 col-12" style="align-self: center;">
                                <button mat-raised-button color="success" type="submit" matTooltip="Consultar"
                                    [disabled]="!formularioDeConsultaDeNotificacoes.valid" style="width: 100%;">
                                    Consultar
                                </button>
                            </div>

                            <div class="form-group col-lg-2 col-md-3 col-sm-12 col-12"
                                style="align-self: center; text-align: right;">
                                <label class="label-creditos">Créditos: {{totalDeCreditosDisponiveis}}</label>
                                <button mat-icon-button color="success" type="button" matTooltip="Atualizar"
                                    (click)="atualizarCreditosDisponiveis()">
                                    <mat-icon>loop</mat-icon>
                                </button>
                            </div>

                        </div>

                    </form>

                    <table mat-table [dataSource]="dataSource" matSort class="table table-striped">
                        <ng-container matColumnDef="numLote">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                width="{{tamanhoDasColunasEmPercent[0]}}"> Lote </th>
                            <td mat-cell *matCellDef="let loteNotificacaoSms"> {{loteNotificacaoSms.numLote}} </td>
                        </ng-container>

                        <ng-container matColumnDef="dataNotificacao">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                width="{{tamanhoDasColunasEmPercent[1]}}"> Data Notific. </th>
                            <td mat-cell *matCellDef="let loteNotificacaoSms"> {{loteNotificacaoSms.dataNotificacao |
                                date:"dd/MM/yyyy HH:mm:ss"}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="dscMotivoNotificacao">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                width="{{tamanhoDasColunasEmPercent[2]}}"> Motivo Notific. </th>
                            <td mat-cell *matCellDef="let loteNotificacaoSms">
                                {{loteNotificacaoSms.dscMotivoNotificacao}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="status">
                            <th mat-header-cell *matHeaderCellDef class="table-column-center"
                                width="{{tamanhoDasColunasEmPercent[3]}}"> Status </th>
                            <td mat-cell *matCellDef="let loteNotificacaoSms" class="table-column-center">
                                <mat-icon class="mat-18" color="{{loteNotificacaoSms.getCorTipoStatusNotificacao()}}"
                                    style="vertical-align: middle;"
                                    matTooltip="{{loteNotificacaoSms.getTooltipTipoStatusNotificacao()}}">
                                    {{loteNotificacaoSms.getIconeTipoStatusNotificacao()}}
                                </mat-icon>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="details">
                            <th mat-header-cell *matHeaderCellDef class="table-column-center"
                                width="{{tamanhoDasColunasEmPercent[4]}}"> Ações </th>
                            <td mat-cell *matCellDef="let loteNotificacaoSms" class="table-column-center">
                                <button mat-icon-button color="primary" (click)="details(loteNotificacaoSms)"
                                    matTooltip="Detalhar">
                                    <mat-icon class="mat-18">info</mat-icon>
                                </button>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                    <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="[10, 30, 50, 70, 100]" showFirstLastButtons>
                    </mat-paginator>
                </div>
            </div>
        </div>
    </div>
</div>